import classNames from "classnames";
import Button from "kustom-front/src/components/atoms/Button";
import { FunctionComponent, useState } from "react";
import { useIntl } from "react-intl";
import { useScript } from "@Hooks/useScript";
import { ReactComponent as IconMail } from "@Icons/mail.svg";
import facebookLogo from "@Images/logo-facebook.png";
import googleLogo from "@Images/logo-google.png";
import FacebookApiProvider from "@Providers/FacebookApiProvider";
import GoogleApiProvider from "@Providers/GoogleApiProvider";
import { ScreenParams } from "@Types/login";
import { getFacebookSdkLocale, logWithProvider } from "./utils";
import "./style.scss";

interface Props {
  onChangeScreen: (newScreenParams: ScreenParams) => void;
  params: ScreenParams;
}

const ProvidersChoice: FunctionComponent<Props> = ({ onChangeScreen, params }) => {
  const [active, setActive] = useState<boolean>(false);
  const intl = useIntl();
  const [errorFacebook] = useScript(
    `https://connect.facebook.net/${getFacebookSdkLocale(intl.locale)}/sdk.js`,
    true
  );
  const [errorGoogle] = useScript("https://apis.google.com/js/api.js", false, false);
  const facebookApiProvider = new FacebookApiProvider();
  const googleApiProvider = new GoogleApiProvider();
  facebookApiProvider.load();

  const handleChangeChoicesScreen = () => {
    setActive(true);
    setTimeout(() => {
      setActive(false);
      onChangeScreen({
        action: params.action === "signUp" ? "signIn" : "signUp",
        screen: "choice",
      });
    }, 100);
  };

  return (
    <div
      className={classNames("ProvidersChoice", {
        "ProvidersChoice--active": active,
      })}
    >
      <div className="ProvidersChoice-description">
        {intl.formatMessage({
          id: `cheerz_LoginModal_${params.page ? params.page : params.action}_choice_description`,
        })}
      </div>
      <Button
        type="primary"
        onClick={() =>
          onChangeScreen({
            action: params.action,
            screen: "email",
          })
        }
      >
        <IconMail />
        {intl.formatMessage({ id: `cheerz_LoginModal_${params.action}_choice_button_email` })}
      </Button>
      {!errorFacebook && (
        <Button
          type="neutral-inverted"
          onClick={() =>
            logWithProvider(
              "facebook",
              facebookApiProvider.getFacebookLoginToken,
              onChangeScreen,
              intl.locale
            )
          }
        >
          <img alt={"facebook"} src={facebookLogo} />
          {intl.formatMessage({ id: `cheerz_LoginModal_${params.action}_choice_button_facebook` })}
        </Button>
      )}
      {!errorGoogle && (
        <Button
          type="neutral-inverted"
          onClick={() =>
            logWithProvider(
              "google",
              googleApiProvider.getGoogleLoginToken,
              onChangeScreen,
              intl.locale
            )
          }
        >
          <img alt={"google"} src={googleLogo} />
          {intl.formatMessage({ id: `cheerz_LoginModal_${params.action}_choice_button_google` })}
        </Button>
      )}
      <div className="ProvidersChoice-switch" onClick={() => handleChangeChoicesScreen()}>
        {intl.formatMessage({ id: `cheerz_LoginModal_${params.action}_choice_switch` })}
      </div>
    </div>
  );
};

export default ProvidersChoice;
